import { Domain } from 'src/app/services/domain.service';

export const sortDomainsByLabel = (domains: Domain[]): Domain[] => {
  return domains.slice().sort((a: Domain, b: Domain) =>
    (a?.label || '').localeCompare(b?.label || '', 'fr', {
      sensitivity: 'base',
      numeric: true,
    })
  );
};
